import { Config } from "../../../core/config/config";

export function getPspRedirectUrl() {
  return Config.CARD_PSP_REDIRECT_WEB_CLIENT_SCHEME;
}
